import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../layouts/full/shared/loadable/Loadable";
import { RouterName } from "./RouterName";
import { dataLocalStorage, getLocalStorage } from "src/helper/publicFunction";

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import("../layouts/full/FullLayout")));
const BlankLayout = Loadable(
  lazy(() => import("../layouts/blank/BlankLayout"))
);

/* ****Pages***** */
const WhatWeDo = Loadable(lazy(() => import("src/pages/what_we_do/view")));
const Clients = Loadable(lazy(() => import("src/pages/clients/view")));
const Blog = Loadable(lazy(() => import("src/pages/blog/view")));
const Services = Loadable(lazy(() => import("src/pages/services/view")));
const CaseStudies = Loadable(lazy(() => import("src/pages/case_study/view")));
const ServicesInfo = Loadable(
  lazy(() => import("src/pages/services_info/view"))
);
const IntroCall = Loadable(lazy(() => import("src/pages/intro_call/view")));

const Testimonials = Loadable(
  lazy(() => import("src/pages/testimonials/view"))
);
const Settings = Loadable(lazy(() => import("src/pages/settings/view")));
const LegalInformation = Loadable(
  lazy(() => import("src/pages/settings/legal_information"))
);
const Profile = Loadable(lazy(() => import("src/pages/settings/profile")));
const Logs = Loadable(lazy(() => import("src/pages/admins_logs/view")));
const Contact_info = Loadable(
  lazy(() => import("src/pages/settings/contact_info"))
);
const Exclusive = Loadable(lazy(() => import("src/pages/settings/exclusive")));
const AboutUs = Loadable(lazy(() => import("src/pages/about_us/view")));
const Projects = Loadable(lazy(() => import("src/pages/projects/view")));

// authentication
const Login = Loadable(
  lazy(() => import("../views/authentication/auth/Login"))
);

const ForgotPassword = Loadable(
  lazy(() => import("../views/authentication/auth/ForgotPassword"))
);
const ResetPassword = Loadable(
  lazy(() => import("src/views/authentication/auth/ResetPassword"))
);

const Error = Loadable(lazy(() => import("../views/authentication/Error")));
const Maintenance = Loadable(
  lazy(() => import("../views/authentication/Maintenance"))
);

const AdminsPage = Loadable(lazy(() => import("../pages/admins/admins/view")));
const PrivilegesPage = Loadable(
  lazy(() => import("../pages/admins/privileges/view"))
);

let data = getLocalStorage(dataLocalStorage.privileges);

const Router = [
  {
    path: "/",
    element: <FullLayout />,
    children: [
      {
        path: "/",
        exact: true,
        element: (
          <Navigate
            to={
              data["1"]?.access_read == 1
                ? RouterName.admins.admins
                : data["5"]?.access_read == 1
                  ? RouterName.settings.settings
                  : data["10"]?.access_read == 1
                    ? RouterName.what_we_do.what_we_do
                    : data["8"]?.access_read == 1
                      ? RouterName.clients.clients
                      : data["6"]?.access_read == 1
                        ? RouterName.about_us.about_us
                        : data["7"]?.access_read == 1
                          ? RouterName.blog.blog
                          : data["4"]?.access_read == 1
                            ? RouterName.profile.profile
                            : data["11"]?.access_read == 1
                              ? RouterName.services.services
                              : data["12"]?.access_read == 1
                                ? RouterName.services_info.services_info
                                : data["9"]?.access_read == 1
                                  ? RouterName.projects.projects
                                  : data["13"]?.access_read == 1
                                    ? RouterName.testimonials.testimonials
                                    : data["1"]?.access_read == 1
                                      ? RouterName.intro_call.intro_call
                                      : data["15"]?.access_read == 1
                                        ? RouterName.case_study.case_study
                                        : data["16"]?.access_read == 1
            }
          />
        ),
      },

      {
        path: RouterName.admins.admins,
        exact: true,
        element: <AdminsPage />,
      },

      data["1"]?.access_read == 1 && {
        path: RouterName.admins.privileges,
        exact: true,
        element: <PrivilegesPage />,
      },

      data["5"]?.access_read == 1 && {
        path: RouterName.settings.settings,
        exact: true,
        element: <Settings />,
      },
      data["5"]?.access_read == 1 && {
        path: RouterName.legal_information.legal_information,
        exact: true,
        element: <LegalInformation />,
      },
      data["14"]?.access_read == 1 && {
        path: RouterName.exclusive.exclusive,
        exact: true,
        element: <Exclusive />,
      },

      data["5"]?.access_read == 1 && {
        path: RouterName.profile.profile,
        exact: true,
        element: <Profile />,
      },
      data["8"]?.access_read == 1 && {
        path: RouterName.clients.clients,
        exact: true,
        element: <Clients />,
      },
      data["6"]?.access_read == 1 && {
        path: RouterName.about_us.about_us,
        exact: true,
        element: <AboutUs />,
      },
      data["7"]?.access_read == 1 && {
        path: RouterName.blog.blog,
        exact: true,
        element: <Blog />,
      },
      data["16"]?.access_read == 1 && {
        path: RouterName.case_study.case_study,
        exact: true,
        element: <CaseStudies />,
      },
      {
        path: RouterName.projects.projects,
        exact: true,
        element: <Projects />,
      },
      {
        path: RouterName.testimonials.testimonials,
        exact: true,
        element: <Testimonials />,
      },
      {
        path: RouterName.what_we_do.what_we_do,
        exact: true,
        element: <WhatWeDo />,
      },

      {
        path: RouterName.services.services,
        exact: true,
        element: <Services />,
      },
      {
        path: RouterName.services_info.services_info,
        exact: true,
        element: <ServicesInfo />,
      },

      {
        path: RouterName.contact_info.contact_info,
        exact: true,
        element: <Contact_info />,
      },


      {
        path: RouterName.admins_logs.admins_logs,
        exact: true,
        element: <Logs />,
      },
      {
        path: RouterName.intro_call.intro_call,
        exact: true,
        element: <IntroCall />,
      }
    ],
  },
  {
    path: "/",
    element: <BlankLayout />,
    children: [
      { path: "/auth/404", element: <Error /> },
      { path: RouterName.auth.login, element: <Login /> },
      { path: RouterName.auth.forgotPassword, element: <ForgotPassword /> },
      { path: RouterName.auth.resetPassword, element: <ResetPassword /> },
      { path: RouterName.auth.maintenance, element: <Maintenance /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
